import * as React from 'react';
import { colors } from '../../../index';

const IconCheckCircle = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 15 15",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M5.259 7.672L4.124 6.516l-.624.636 1.497 1.525L5 8.675l.274.279L9.5 4.648 8.864 4z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 6.5,
    cy: 6.5,
    r: 6.5
  })));
};

export default IconCheckCircle;